import { ApiClient } from 'app/service/api-service'
import { AEventEndPoint } from './constant'
import {
  IPayloadCreateActivityEvent,
  IPayloadUpdateActivityEvent,
} from './model'
export const requestPostCreateActivityEvent = (
  body: IPayloadCreateActivityEvent,
) =>
  ApiClient.Post({
    url: AEventEndPoint.CREATE,
    body,
  })

export const requestUpdateActivityEvent = (body: IPayloadUpdateActivityEvent) =>
  ApiClient.Put({
    url: AEventEndPoint.UPDATE,
    body,
  })

export const requestDetailActivity = (id: number) =>
  ApiClient.Post({
    url: AEventEndPoint.DETAIL,
    body: { id },
  })

export const requestDeleteActivityEvent = (id: number) =>
  ApiClient.Put({
    url: AEventEndPoint.DELETE,
    body: { id },
  })
